import styles from "./SummaryCard.module.scss";

interface SummaryCardProps {
    title: string;
    value: string;
    /** Period-over-period trend, rendered with an arrow and "from last period". */
    percentageChange?: number;
    /** Share of a total (e.g. successful requests / total requests), rendered as a plain percentage. */
    sharePercentage?: number;
}

export const SummaryCard = ({ title, value, percentageChange, sharePercentage }: Readonly<SummaryCardProps>) => {
    const getIndicatorClass = () => {
        if (percentageChange === undefined) return styles.neutral;
        if (percentageChange > 0) return styles.positive;
        if (percentageChange < 0) return styles.negative;
        return styles.neutral;
    };

    const getArrowSymbol = () => {
        if (percentageChange === undefined) return "";
        if (percentageChange > 0) return "↑";
        if (percentageChange < 0) return "↓";
        return "→";
    };

    return (
        <div className={styles.card}>
            <span className={styles.title}>{title}</span>
            <h3 className={styles.value}>{value}</h3>
            {sharePercentage !== undefined && (
                <div className={`${styles.indicator} ${styles.neutral}`}>
                    <span className={styles.percentage}>{sharePercentage}%</span>
                </div>
            )}
            {sharePercentage === undefined && percentageChange !== undefined && (
                <div className={`${styles.indicator} ${getIndicatorClass()}`}>
                    <span className={styles.arrow}>{getArrowSymbol()}</span>
                    <span className={styles.percentage}>{Math.abs(percentageChange)}%</span>
                    <span className={styles.label}>from last period</span>
                </div>
            )}
        </div>
    );
};
